import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportTransactions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 27,
	viewBox: "0 0 31 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0H14.3733L20.5333 5.22667V26.1333H0V0Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.1833 9.3327L21.1833 11.7417L14 11.7417L13.25 11.7417L13.25 12.4917L13.25 16.4404L13.25 17.1904L14 17.1904L21.1833 17.1904L21.1833 19.5994L21.1833 21.2164L22.4178 20.1719L28.4845 15.0386L29.1611 14.466L28.4845 13.8935L22.4178 8.76016L21.1833 7.71562L21.1833 9.3327Z",
		fill: "#FF3131",
		stroke: "white",
		strokeWidth: 1.5
	})]
});
export default SvgExportTransactions;
